import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicOpen({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M6.45 1.9c.28 0 .5.22.5.5v.5a.5.5 0 01-.5.5h-2.9c-.2 0-.35.15-.35.35v8.8c0 .2.16.35.35.35h8.8c.2 0 .35-.16.35-.35v-2.9c0-.28.22-.5.5-.5h.5c.28 0 .5.22.5.5v2.9c0 1.02-.83 1.85-1.85 1.85h-8.8a1.85 1.85 0 01-1.85-1.85v-8.8c0-1.02.83-1.85 1.85-1.85zm7.81-.67c.24 0 .43.2.43.43v4.9c0 .25-.2.44-.43.44h-.56a.43.43 0 01-.43-.44l.07-2.97-5.65 5.5a.43.43 0 01-.6 0l-.4-.4a.43.43 0 010-.6l5.64-5.51-2.97.07a.43.43 0 01-.43-.43v-.56c0-.24.19-.43.42-.43h4.91z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicOpen.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicOpen.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicOpen svgRef={ref} {...props} />);
export default ForwardRef;
